import Cookies from 'js-cookie'
import CONSTANTS from '@/constants'
import { nanoid } from 'nanoid'

const MetadataKey = 'metadata_key'

export function getDeviceId() {
    let x = Cookies.get(CONSTANTS.COOKIE_DEVICE_ID)
    if (x) {
        return x
    } else {
        x = nanoid(50)
        setDeviceId(x, CONSTANTS.COOKIE_EXPIRE_DAY)
        return x
    }
}

export function setDeviceId(device_id, expires) {
    if (expires == 0) {
        return Cookies.set(CONSTANTS.COOKIE_DEVICE_ID, device_id)

    } else {
        return Cookies.set(CONSTANTS.COOKIE_DEVICE_ID, device_id, { expires: expires })
    }
}

export function setStepRegister(step) {
    window.localStorage.setItem('step_register', step)
}
export function getStepRegister() {
    return window.localStorage.getItem('step_register')
}

export function setVerifyPhone(value = CONSTANTS.IS_VERIFY_PHONE_NUMBER) {
    window.localStorage.setItem('is_verify_phone', value)
}
export function getVerifyPhone() {
    return window.localStorage.getItem('is_verify_phone')
}

export function setPushToken(token) {
    window.localStorage.setItem('push_token', token)
}

export function setLoginBonus(val) {
    window.localStorage.setItem('isBonus',val)
}
export function setLoginDayNumber(val) {
    window.localStorage.setItem('loginDayNumber', val)
}

export function getLoginBonus() {
    return window.localStorage.getItem('isBonus')
}

export function getLoginDayNumber() {
    return window.localStorage.getItem('loginDayNumber')
}

export function getPushToken() {
    return window.localStorage.getItem('push_token')
}

export function removeDeviceId() {
    return Cookies.remove(CONSTANTS.COOKIE_DEVICE_ID)
}

export function getToken() {
    return Cookies.get(CONSTANTS.COOKIE_TOKEN)
}

export function setToken(token, expires) {
    if (expires == 0) {
        return Cookies.set(CONSTANTS.COOKIE_TOKEN, token)

    } else {
        return Cookies.set(CONSTANTS.COOKIE_TOKEN, token, { expires: expires })
    }
}

export function removeToken() {
    return Cookies.remove(CONSTANTS.COOKIE_TOKEN)
}

export function getAccessToken() {
    return Cookies.get(CONSTANTS.COOKIE_ACCESS_TOKEN)
}

export function setAccessToken(token, expires) {
    if (expires == 0) {
        return Cookies.set(CONSTANTS.COOKIE_ACCESS_TOKEN, token)

    } else {
        return Cookies.set(CONSTANTS.COOKIE_ACCESS_TOKEN, token, { expires: expires })
    }
}

export function removeAccessToken() {
    return Cookies.remove(CONSTANTS.COOKIE_ACCESS_TOKEN)
}

export function getRememberMe() {
    return Cookies.get(CONSTANTS.COOKIE_SESSION_REMEMBER_ME)
}

export function setRememberMe(expires) {
    if (expires == 0) {
        return Cookies.set(CONSTANTS.COOKIE_SESSION_REMEMBER_ME, '1')

    } else {
        return Cookies.set(CONSTANTS.COOKIE_SESSION_REMEMBER_ME, '1', { expires: expires })
    }
}

export function setSessionRememberMe() {
    return sessionStorage.setItem(CONSTANTS.COOKIE_SESSION_REMEMBER_ME, 1);
}
  
export function getSessionRememberMe() {
    return sessionStorage.getItem(CONSTANTS.COOKIE_SESSION_REMEMBER_ME);
}

export function removeRememberMe() {
    return Cookies.remove(CONSTANTS.COOKIE_SESSION_REMEMBER_ME)
}

export function getCookieMetadata() {
    const data = Cookies.get(MetadataKey)
    return data !== null && (typeof metadata !== 'undefined') ? JSON.parse(data) : null
}

export function setCookieMetadata(metadata) {
    return Cookies.set(MetadataKey, metadata)
}

export function removeMetadata() {
    return Cookies.remove(MetadataKey)
}

export function setMessageTab(type) {
    return sessionStorage.setItem('message_tab_type', type);
}

export function getMessageTab(type) {
    return sessionStorage.getItem('message_tab_type');
}

export function removeMessageTab(type) {
    return sessionStorage.removeItem('message_tab_type');
}

export function setSession(name, val) {
    return sessionStorage.setItem(name, val);
}
  
export function getSession(name) {
    return sessionStorage.getItem(name);
}

export function removeSession(name) {
    return sessionStorage.removeItem(name);
}
